/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ban_PalestineInputs */

const en_ban_palestine = /** @type {(inputs: Ban_PalestineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Palestine`)
};

const ar_ban_palestine = /** @type {(inputs: Ban_PalestineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`فلسطين`)
};

const bn_ban_palestine = /** @type {(inputs: Ban_PalestineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ফিলিস্তিন`)
};

const de_ban_palestine = /** @type {(inputs: Ban_PalestineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Palästina`)
};

const es_ban_palestine = /** @type {(inputs: Ban_PalestineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Palestina`)
};

const fr_ban_palestine = /** @type {(inputs: Ban_PalestineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Palestine`)
};

const pt_ban_palestine = /** @type {(inputs: Ban_PalestineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Palestina`)
};

const zh_ban_palestine = /** @type {(inputs: Ban_PalestineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`巴勒斯坦`)
};

const tr_ban_palestine = /** @type {(inputs: Ban_PalestineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filistin`)
};

const ru_ban_palestine = /** @type {(inputs: Ban_PalestineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Палестина`)
};

const pl_ban_palestine = /** @type {(inputs: Ban_PalestineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Palestyna`)
};

/**
* | output |
* | --- |
* | "Palestine" |
*
* @param {Ban_PalestineInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const ban_palestine = /** @type {((inputs?: Ban_PalestineInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ban_PalestineInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_ban_palestine(inputs)
	if (locale === "bn") return bn_ban_palestine(inputs)
	if (locale === "de") return de_ban_palestine(inputs)
	if (locale === "es") return es_ban_palestine(inputs)
	if (locale === "fr") return fr_ban_palestine(inputs)
	if (locale === "pt") return pt_ban_palestine(inputs)
	if (locale === "zh") return zh_ban_palestine(inputs)
	if (locale === "tr") return tr_ban_palestine(inputs)
	if (locale === "ru") return ru_ban_palestine(inputs)
	if (locale === "pl") return pl_ban_palestine(inputs)
	return en_ban_palestine(inputs)
});